import React from 'react';
import { assertNever } from '@varos/util-typescript';
import { ReportingContainerBaseConfig } from '../../../base';
import {
    DocumentDetailController,
    DocumentDetailLoader,
} from './documentDetailInterface';
import {
    DocumentDetailContainerProps,
    DocumentDetailViewProps,
} from './documentDetailProps';
import { DocumentEditorContainerProps } from '../editor';
import { DocumentDetailParameterSchema } from './documentDetailSchema';
import { DocumentFormContainerProps, FormBuilderContainerProps } from '../form';

export function createDocumentDetailContainer(
    config: ReportingContainerBaseConfig & {
        Container: {
            Form: React.FC<DocumentFormContainerProps>;
            Editor: React.FC<DocumentEditorContainerProps>;
        };
    },
    loader: DocumentDetailLoader,
    controller: DocumentDetailController
): React.FC<DocumentDetailContainerProps> {
    const {
        kernel: {
            infra: {
                optionParser: { useOptions },
            },
        },
        context: { useContext },
        Container: { Form: DocumentFormContainer, Editor: DocumentEditorContainer },
    } = config;

    return config.state.editor.subscribe(({ ...containerProps }) => {
        const context = useContext();
        const options = useOptions(DocumentDetailParameterSchema);
        const data = loader.useLoad(context, {
            document: {
                id: options.contentId,
            },
        });
        const props = controller.useProps(context, data, {});
        if (props.content.kind === 'form') {
            return <DocumentFormContainer {...props.content.props} />;
        }
        if (props.content.kind === 'editor') {
            return <DocumentEditorContainer />;
        }
        assertNever(props.content);
    });
}
